import { Component } from '@angular/core';

@Component({
    selector: 'app-wrapper',
    templateUrl: './app-wrapper.component.html',
    styleUrls: ['./app-wrapper.component.css'],
    standalone: false
})
export class AppWrapperComponent {

}
